<template>
  <div>
    <div>
      <el-row class="bgW">
      <el-col :span="20">
        <!--检索条件-->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">

           <el-form-item label="日期">
            <el-date-picker
              v-model="search.start_time"
              type="date"
              class="w130"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-date-picker
              v-model="search.end_time"
              type="date"
              class="w130"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4" class="btnBox">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
        <!-- <el-button type="primary" class="mb10" size="mini"  :loading="exportS" @click="exportExcel">导出数据</el-button> -->
      </el-col>
    </el-row>

      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
			      max-height="750"
            style="width: 100%"
            border
            v-loading="loading"
            :span-method="objectSpanMethod"
            :cell-style="cellStyle"
            :header-cell-style="rowClass"
          >
            <ElTableColumn label="市场" prop="market_name" label-class-name="market"/>
            <ElTableColumn label="店面" prop="shop_name" />
            <ElTableColumn label="合计">
              <el-table-column label="合计本金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.balance_sum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="合计赠金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.gift_sum}}</div>
                </template>
              </el-table-column>
              <el-table-column label="合计店转" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.store_sum}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>
            <ElTableColumn label="护理数据">
              <el-table-column label="护理消耗本金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.service_consume_balance}}</div>
                </template>
              </el-table-column>
              <el-table-column label="护理消耗赠金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.service_consume_gift}}</div>
                </template>
              </el-table-column>
              <el-table-column label="护理消耗店转" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.service_consume_store}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>   
            <ElTableColumn label="产品维度">
              <el-table-column label="产品出库本金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.goods_out_balance}}</div>
                </template>
              </el-table-column>
              <el-table-column label="产品出库赠金" >
                 <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.goods_out_gift}}</div>
                </template>
              </el-table-column>
              <el-table-column label="产品出库店转" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.goods_out_store}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>   
            <ElTableColumn label="门店转诊">
              <el-table-column label="医美转出本金" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.referral_balance}}</div>
                </template>
              </el-table-column>
              <el-table-column label="医美转出赠金" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.referral_gift}}</div>
                </template>
              </el-table-column>
              <el-table-column label="医美转出店转" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.referral_store}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>   
            <ElTableColumn label="预存核销">
             <el-table-column label="预存核销本金" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.prestock_cancel_balance}}</div>
                </template>
              </el-table-column>
              <el-table-column label="预存核销赠金" >
                  <template slot-scope="{ row }">
                    <div class="hand" @click="clickOnline(row,row.id)">{{row.prestock_cancel_gift}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="预存核销店转" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.prestock_cancel_store}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>   
            <ElTableColumn label="项目">
              <el-table-column label="项目核销本金" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.project_cancel_balance}}</div>
                </template>
              </el-table-column>
              <el-table-column label="项目核销赠金" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.project_cancel_gift}}</div>
                </template>
              </el-table-column>
              <el-table-column label="项目核销店转" >
                <template slot-scope="{ row }">
                  <div class="hand" @click="clickOnline(row,row.id)">{{row.project_cancel_store}}</div>
                </template>
              </el-table-column>
            </ElTableColumn>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getLastDay } from '@/utils';
import pagination from "@/components/Pagination";
import { getConsumeList } from "@/api/statistics";

class Search {
  start_time = "";
  end_time = "";
}
export default {
  name: "OrderList",
  components: {
    pagination
  },
  data() {
    return {
      search: new Search(), // 检索条件
      list: [], // 数据展示
      loading:false,
      exportS: false,
      mergeRules: [],
      currentMarket: null, // 当前分组的 market_name
      currentCount: 0 
    };
  },
  mounted() {
    let year = new Date().getFullYear()
    let month = new Date().getMonth() + 1
    if(month.toString().length == 1){
      month = '0'+ month
    }
    let day = getLastDay(year,month)
    if(day.toString().length == 1){
      day = '0'+ day
    }
    this.search.start_time = year+'-'+ month + '-01'
    this.search.end_time = year+'-'+ month + '-' + day
    this.getList('search');

  },
  methods: {
   getList(option) {
      this.loading = true
      getConsumeList({ ...this.search}).then(res => {
        this.list = res.data.list;
        // 关键修复：按 market_name 排序，保证同市场连续
        this.list.sort((a, b) => a.market_name.localeCompare(b.market_name));
        this.initSpanArr(); // 重新生成合并规则
        this.loading = false
      });
    },

  initSpanArr() {
      this.mergeRules = [];
      const marketGroups = []; // 存储每个市场的 { 起始索引, 行数 }
      let currentMarket = null; // 当前市场名称
      let currentStart = 0;     // 当前市场的起始索引
      let currentCount = 0;     // 当前市场的连续行数

      this.list.forEach((item, index) => {
        if (item.market_name === currentMarket) {
          currentCount++;
        } else {
          if (currentMarket !== null) {
            marketGroups.push({ start: currentStart, count: currentCount });
          }
          currentMarket = item.market_name;
          currentStart = index;
          currentCount = 1;
        }
      });
      if (currentMarket !== null) {
        marketGroups.push({ start: currentStart, count: currentCount });
      }
      this.mergeRules = new Array(this.list.length).fill(0);
      marketGroups.forEach(group => {
        this.mergeRules[group.start] = group.count;
      });
},
  objectSpanMethod({ rowIndex, columnIndex }) {
    console.log(this.mergeRules,"this.mergeRules")
    if (columnIndex === 0) {
      const rowspan = this.mergeRules[rowIndex];
      return { rowspan, colspan: 1 };
    }
    return { rowspan: 1, colspan: 1 };
  },
  cellStyle({row, column, rowIndex, columnIndex}){
    if(columnIndex <= 1){
        return 'background:#fff0c8;text-align:center' // 柔和浅黄
    }
    if(columnIndex > 1 && columnIndex <= 4){
        return 'background:#d1e7dd;text-align:center' // 清新浅绿
    }
    if(columnIndex > 4 && columnIndex <= 7){
        return 'background:#d6e4ff;text-align:center' // 淡蓝色
    }
    if(columnIndex > 7 && columnIndex <= 10){
        return 'background:#f8d7da;text-align:center' // 浅粉色
    }
    if(columnIndex > 10 && columnIndex <= 13){
        return 'background:#e6f7ff;text-align:center' // 微蓝白
    }
    if(columnIndex >= 14 && columnIndex <= 16){
        return 'background:#f3e5f5;text-align:center' // 淡紫色
    }
    if(columnIndex >= 17){
        return 'background:#fff3e0;text-align:center' // 浅橙色
    }
      // if(columnIndex = 21){
      //     return 'background:#FFFF99;text-align:center'
      // }
      // if(columnIndex = 22){
      //     return 'background:#FFFF99;text-align:center'
      // }
      return '';
  },

      rowClass({row, column, rowIndex, columnIndex}){
        return 'background:#E9EDEE;text-align:center'

      },
    // 导出
    // exportExcel() {
    //   this.exportS = true
    //   shopDk({...this.search,export:1}).then(res => {
    //     window.open(res.data.url);
    //     this.exportS = false
    //   });
    // },
    // 跳转事件
    clickOnline(row,id){
      // this.$router.push("./entranceShop?shop_id="+row.shop_id + '&source_id='+id  + '&start_time='+this.search.start_time + '&end_time='+this.search.end_time);
    },
  }
};
</script>

<style lang="scss" scoped>
.hand{
  cursor:pointer;
}
.btnBox{
  text-align: right;
}
.market{
  background: red;
}
</style>
